export function formatTimestamp(seconds?: number | null) {
    if (seconds === null || seconds === undefined) {
        return '';
    }
    let temp = seconds;
    const minutes = Math.floor((temp %= 3600) / 60);
    const remainingSeconds = Math.floor(temp % 60);
    const secondsText = remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;

    return `${minutes}:${secondsText}`;
}
